import { TopOfBookSource } from '@api/core';
import { TopOfBookFormModel } from '@shared/store/features/shared-settings/top-of-book.feature';

export function getValueByType(value: TopOfBookFormModel): TopOfBookSource {
  const source = {
    type: value.type,
    name: value.name,
    enabled: !!value.enabled,
    pairId: value.pair?.id,
  };

  switch (value.type) {
    case TopOfBookSource.TypeEnum.Aggregate:
    case TopOfBookSource.TypeEnum.Multiply:
    case TopOfBookSource.TypeEnum.Divide:
    case TopOfBookSource.TypeEnum.PerpSpotChaining:
      return {
        ...source,
        source1: value.source1?.id,
        source2: value.source2?.id,
        ...(value.type === TopOfBookSource.TypeEnum.Aggregate
          ? {
              weight1: value.weight1,
              weight2: value.weight2,
              source3: value.source3?.id,
              source4: value.source4?.id,
              weight3: value.weight3,
              weight4: value.weight4,
            }
          : {}),
      };
    default:
      return source;
  }
}
